import React from 'react';
import { ApplogLevel } from 'src/api/FiretrolApiClient';
import { Badge } from 'src/design/atoms/Badge';
import {
  getApplogLevelColor,
  getApplogLevelLabel,
} from 'src/routes/Settings/Applogs/applogFilters';

export interface IApplogLevelBadgeProps {
  level: ApplogLevel;
}

export const ApplogLevelBadge: React.FC<IApplogLevelBadgeProps> = ({
  level,
}) => (
  <Badge color={getApplogLevelColor(level)} variant="light">
    {getApplogLevelLabel(level)}
  </Badge>
);
